module.exports = __webpack_public_path__ + "images/BMWLogo__3720911edb02e0464fec7a9857f20e16.png";